import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Spinner } from "react-bootstrap";
import { postRequest } from "../../system/server-call";
import { ToastifyService } from "../../services";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (!email.trim()) {
      setError("Please enter your email address.");
      return;
    }

    setLoading(true);
    try {
      await postRequest("auth/forgot-password", { email });
      setDone(true);
      ToastifyService.showSuccess(
        "Password reset instructions have been sent to your email."
      );
    } catch (err) {
      const msg =
        err?.response?.data?.message ||
        "Something went wrong. Please try again.";
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page-wrapper pt-5">
      <div className="auth-page-content">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-8 col-lg-6 col-xl-5">
              <div className="card mt-4 card-bg-fill">
                <div className="card-body p-4">
                  {done ? (
                    <div className="text-center py-4">
                      <div
                        style={{
                          width: 64,
                          height: 64,
                          borderRadius: "50%",
                          background: "#d1fae5",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          margin: "0 auto 16px",
                        }}
                      >
                        <i
                          className="ri-mail-send-line"
                          style={{ fontSize: 36, color: "#059669" }}
                        />
                      </div>
                      <h5 className="text-success mb-2">Check Your Email</h5>
                      <p className="text-muted mb-4">
                        If an account exists for <strong>{email}</strong>, we have
                        sent instructions to reset your password.
                      </p>
                      <Link to="/login" className="btn btn-primary w-100">
                        Back to Login
                      </Link>
                    </div>
                  ) : (
                    <>
                      <div className="text-center mt-2">
                        <h5 className="text-primary">Forgot Password?</h5>
                        <p className="text-muted">
                          Enter your email to receive a password reset link.
                        </p>
                      </div>

                      <div className="p-2 mt-4">
                        <form onSubmit={handleSubmit} className="h-auto">
                          <div className="mb-3">
                            <label htmlFor="email" className="form-label">
                              Email Address
                            </label>
                            <input
                              type="email"
                              id="email"
                              className="form-control"
                              placeholder="Enter your email"
                              value={email}
                              onChange={(e) => setEmail(e.target.value)}
                              required
                            />
                          </div>

                          {error && (
                            <div className="alert alert-danger py-2" role="alert">
                              {error}
                            </div>
                          )}

                          <div className="mt-4">
                            <button
                              type="submit"
                              className="btn btn-success w-100"
                              disabled={loading}
                            >
                              {loading ? (
                                <>
                                  <Spinner
                                    animation="border"
                                    size="sm"
                                    className="me-2"
                                  />
                                  Sending reset link...
                                </>
                              ) : (
                                "Send Reset Link"
                              )}
                            </button>
                          </div>
                        </form>
                      </div>
                    </>
                  )}
                </div>
              </div>

              <div className="mt-4 text-center">
                <p className="mb-0 text-muted">
                  Wait, I remember my password...{" "}
                  <Link
                    to="/login"
                    className="fw-semibold text-primary text-decoration-underline"
                  >
                    Sign In
                  </Link>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
